<template>
    <div>
        <div v-if="googleFilesSelect.length > 0">
            <label for="google_file_autocomplete">
                Fichier Google Sheets à importer
            </label>

            <Autocomplete
                id="google_file_autocomplete"
                class=" rounded-lg focus:outline-none"
                @submit="(val) => selectedFile = val"
                placeholder="Cherchez un fichier dans votre drive"
                :defaultValue="''"
                :search="(search) => autocompleteDriveFiles(search)"
                :get-result-value="result => result"
                :autoSelect="true">
                <template #result="{ result, props }">
                    <li
                        v-bind="props"
                        class="autocomplete-result"
                    >
                        <div class=" z-20">
                            {{ result }}
                        </div>
                    </li>
                </template>
            </Autocomplete>
        </div>

        <div v-show="fileSheets.length > 0">
            <label for="Range_input">
                Nom de la feuille à importer
            </label>
            <b-form-select
                id="Range_input"
                v-model="range"
                :options="fileSheets"
                class="mb-2">
            </b-form-select>
        </div>
        <hr/>

        <!-- Import section -->
        <div v-show="props.hideImportOptions === false">

            <div>
                <b-form-checkbox
                    v-model="importGed"
                    class="mb-2"
                    style="z-index: 0;"
                    switch>
                    Importer la feuille dans le gestionnaire de documents.
                </b-form-checkbox>
            </div>

            <div v-if="importGed === false">
                <label for="Table_name">Nom de la table SMD</label>
                <input
                    id="Table_name"
                    class="rounded-md p-1 w-full leading-relaxed mb-2"
                    v-model="tableName"
                    placeholder="Nom de la table SMD"/>
                <hr/>
            </div>
            
            <div v-if="importGed">
                <label for="File_name">Nom du document</label>
                <input
                    id="File_name"
                    class="rounded-md p-1 w-full leading-relaxed mb-2"
                    v-model="fileName"
                    placeholder="Nom du document"/>
                <hr/>
            </div>

        </div>
        <div>
            <b-button :variant="fieldsFilled ? 'success' : ''" :disabled="!fieldsFilled"
                @click="() => onValidate()">
                Valider
            </b-button>
        </div>

    </div>
</template>

<script setup>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import { computed, onMounted, ref, watch } from "vue";

const props = defineProps({
    credentialName: {
        type: String,
        required: true
    },
    fileSheets: {
        type: Array,
        required: true
    },
    googleFilesSelect: {
        type: Array,
        required: true
    },
    autocompleteDriveFiles: {
        type: Function,
        required: true
    },

    hideImportOptions: {
        type: Boolean,
        required: false,
        default: false
    }
});

const selectedFile = ref("");
const range = ref("");
const fileName = ref("");
const tableName = ref("");

const emits = defineEmits(["importGed", "importTable", "reloadSheets", "returnRaw"]);

const onValidate = () => {
    console.log("Validated");

    // if hide import, emit specific event
    if (props.hideImportOptions) {
        // emits('importGed', selectedFile.value, range.value, fileName.value);
        emits('returnRaw', selectedFile.value, range.value);
        return;
    }

    if (importGed.value) {
        console.log("Emitting importGed");
        emits('importGed', selectedFile.value, range.value, fileName.value);
    } else {
        console.log("Emitting importTable");
        emits('importTable', selectedFile.value, range.value, tableName.value);
    }
    // importGed ? emits('importGed', selectedFile, range, fileName) : emits('importTable', selectedFile, range, tableName)
}

watch(() => props.googleFilesSelect, async (newVal, oldVal) => {
    if (newVal.length > 0) {
        selectedFile.value = "";
        fileName.value = "";
        tableName.value = "";
    }
});

watch(() => props.fileSheets, async (newVal, oldVal) => {
    if (newVal.length > 0) {
        range.value = newVal[0].value;

        if (selectedFile.value.length > 0) {
            // filename and tablename are set
            fileName.value = selectedFile.value;
            tableName.value = selectedFile.value;
        }
    }
});

const importGed = ref(true);

const fieldsFilled = computed(() => {

    // if hide import, we only need selectedFile
    if (props.hideImportOptions) {
        return selectedFile.value.length > 0;
    }

    if (importGed.value) {
        return selectedFile.value.length > 0 && fileName.value.length > 0 && props.credentialName.length > 0;
    } else {
        return selectedFile.value.length > 0 && tableName.value.length > 0 && props.credentialName.length > 0;
    }
});


watch(selectedFile, async (newVal, oldVal) => {
    emits("reloadSheets", newVal);
});

onMounted(async () => {
});

</script>